export default __webpack_public_path__ + "static/media/travis-ci-monochrome.8a37e0df.svg";